<template>
  <div>
    <div class="grid-container">
      <div class="grid-row">
        <div class="tablet:grid-col-4">
          <h3 class="site-preview-heading">Site Information</h3>
          <ul class="usa-list usa-list--unstyled">
            <li>
              Latitude: {{ rowSelected.latitude }},
              {{ rowSelected.coordinateDatumCode }}
            </li>
            <li>
              Longitude: {{ rowSelected.longitude }},
              {{ rowSelected.coordinateDatumCode }}
            </li>
            <li>
              <button
                class="usa-button"
                type="submit"
                :disabled="loading"
                @click="viewDetails"
              >
                View Configuration
              </button>
            </li>
            <li>
              <button
                class="usa-button"
                type="submit"
                :disabled="loading"
                @click="downloadDetails"
              >
                Download Configuration
              </button>
            </li>
          </ul>
        </div>
        <div class="tablet:grid-col-6">
          <USWDSTable
            caption="Platform Sensor Information"
            :fields="sensorColumns"
            :items="sensors"
          ></USWDSTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import USWDSTable from "@/components/USWDSTable.vue";
import axios from "axios";

export default {
  name: "DetailedPlatformView",
  emits: ["loading"],
  components: {
    USWDSTable,
  },
  props: {
    rowSelected: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      sensorColumns: [
        { key: "sensorName", label: "Sensor Name" },
        { key: "aqtsIdentifier", label: "AQTS Name" },
        { key: "parameterCode", label: "Param Code" },
      ],
      detailedPlatformInformation: {},
      loading: false,
    };
  },
  computed: {
    sensors() {
      if (this.detailedPlatformInformation.platform) {
        return this.detailedPlatformInformation.platform.sensors;
      }
      return {};
    },
  },
  watch: {
    loading() {
      this.$emit("loading", this.loading);
    },
  },
  mounted() {
    this.loading = true;
    return axios
      .get("retrieval?platformId=" + this.rowSelected.platformId)
      .then((response) => {
        this.detailedPlatformInformation = response.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    viewDetails() {
      var jsonString = JSON.stringify(
        this.detailedPlatformInformation,
        null,
        4
      );
      var tab = window.open("about:blank", "_blank");
      tab.document.write("<pre>" + jsonString + "</pre>");
      tab.document.close();
    },
    downloadDetails() {
      var jsonString = JSON.stringify(
        this.detailedPlatformInformation,
        null,
        2
      );
      const blob = new Blob([jsonString], { encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        this.detailedPlatformInformation.platform.siteNumber +
        "_" +
        this.detailedPlatformInformation.platform.transmissionId +
        ".json";
      link.click();
    },
  },
};
</script>
